import { createFileRoute } from '@tanstack/react-router';

import { UserDocumentAdminBrowse } from '@/module/UserDocument/UserDocumentAdminBrowse';

export const Route = createFileRoute('/_auth/administration/_administration/user-documents/_user-documents/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <UserDocumentAdminBrowse />;
}
